'use strict';

var react = require('react');
var utilities_assertUnreachable = require('../../utilities/assertUnreachable.js');
var hooks_dataFetchingHooks_useQuery = require('./useQuery.js');
require('../useCallbackRef.js');

const toStaticQueryState = (state) => {
    switch (state.status) {
        case 'loading':
        case 'error':
        case 'loaded': {
            return state;
        }
        case 'idle': {
            throw new Error('This state should not be possible');
        }
        default: {
            throw new Error(utilities_assertUnreachable.assertUnreachable(state));
        }
    }
};
/**
 * Use this hook when you need to fetch data once the component is rendered and the request doesn't have parameters.
 * @see https://dev.azure.com/templafy/Templafy/_wiki/wikis/Engineering%20Wiki/1406/useStaticQuery
 */
const useStaticQuery = ({ action, }) => {
    const { state, retry, fetch } = hooks_dataFetchingHooks_useQuery.useQuery({
        action,
        initialQuery: undefined,
    });
    return {
        refetch: react.useRef(() => fetch(undefined)).current,
        retry,
        state: toStaticQueryState(state),
    };
};

exports.useStaticQuery = useStaticQuery;
//# sourceMappingURL=useStaticQuery.js.map
